import React, {
  forwardRef,
  RefObject,
  useImperativeHandle,
  useLayoutEffect,
  useState,
} from 'react'
import { Button, Modal } from 'react-bootstrap'
import { IModalReference } from 'shared/models/References'
import { VestigingEnum } from '../models/Enum'
import { ILocatieGlnModel } from '../models/ILocatieGlnModel'
import GlnService from '../service/GlnService'

interface IProps {
  onLinkedAddress: (address: ILocatieGlnModel) => void
  onHide?: () => void
  onShow?: () => void
  showModal?: boolean
  warehouse: VestigingEnum
}

function AddressSearch(props: IProps, ref: RefObject<IModalReference>) {
  const [koppelLocaties, setKoppelLocaties] = useState<ILocatieGlnModel[]>()
  const [address, setAddress] = useState('')
  const [errorMessage, setErrorMessage] = useState<string>()
  const [showModal, setShowModal] = useState(false)

  useLayoutEffect(() => {
    if (props.showModal != null && props.showModal !== showModal) {
      if (props.showModal) {
        show()
      } else {
        hide()
      }
    }
  }, [props.showModal])

  useImperativeHandle(ref, () => ({
    show: () => {
      show()
    },
    hide: () => {
      hide()
    },
  }))

  const show = () => {
    if (!showModal) {
      setShowModal(true)
      if (!!props.onShow) {
        props.onShow()
      }
    }
  }

  const hide = () => {
    if (showModal) {
      setShowModal(false)
      if (!!props.onHide) {
        props.onHide()
      }
    }
  }

  const linkedAddress = (linked: ILocatieGlnModel) => {
    props.onLinkedAddress(linked)
    hide()
  }

  const renderLocatieRows = (data: ILocatieGlnModel[]) => {
    return data.map(x => {
      return (
        <tr key={x.locatieGlnId}>
          <td>{x.locatieGlnCode}</td>
          <td>{x.locatieGlnNaam}</td>
          <td>{x.locatieGlnOmschrijving}</td>
          <td>{getWarehouse(x.vestigingCode)}</td>
          <td>
            <Button variant='primary' onClick={() => linkedAddress(x)}>
              Koppel
            </Button>
          </td>
        </tr>
      )
    })
  }

  const getWarehouse = (code: number): string => {
    return VestigingEnum[code]
  }

  const searchAddressesIfEnter = (e: string) => {
    if (e === 'Enter') {
      searchAddresses()
    }
  }

  const searchAddresses = async () => {
    if (!!address && address.length > 0) {
      const result = await GlnService.getKoppelLocaties(
        address,
        props.warehouse
      )
      if (result.success) {
        setErrorMessage(null)
        setKoppelLocaties(result.payLoad)
      } else {
        setErrorMessage(result.errorMessage)
        setKoppelLocaties(null)
      }
    }
  }

  const setAddressField = (e: string) => {
    setAddress(e)
    setKoppelLocaties(null)
  }

  return (
    <Modal
      show={showModal}
      onHide={hide}
      animation={false}
      className='modal-stack2'
      dialogClassName='new-modal'
      size='xl'
      
    >
      <Modal.Header closeButton>
        <Modal.Title>Zoeken adres</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorMessage != null && (
          <div className='alert alert-danger'>{errorMessage}</div>
        )}
        <table className='selectie'>
          <thead>
            <tr>
              <th className='selectie-label'>Adressen:</th>
              <th className='selectie-label'></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <input
                  value={address}
                  placeholder='zoek adres...'
                  onChange={e => setAddressField(e.target.value)}
                  onKeyUp={e => searchAddressesIfEnter(e.key)}
                />
              </td>
              <td>
                <div className='row no-gutters'>
                  <div className='col'></div>
                  <div className='col-auto'>
                    <button
                      className='btn btn-primary'
                      disabled={!address || address.length === 0}
                      onClick={() => searchAddresses()}
                    >
                      Zoek Adressen
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        {!!koppelLocaties && (
          <React.Fragment>
            <table className='table'>
              <thead>
                <tr>
                  <th>Locatie Gln</th>
                  <th>Locatie Naam</th>
                  <th>Omschrijving</th>
                  <th>Vestiging</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>{renderLocatieRows(koppelLocaties)}</tbody>
            </table>
          </React.Fragment>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={hide}>
          Sluiten
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
export default forwardRef(AddressSearch)
